import React, { useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { pluralize } from 'humanize-plus';
import PropTypes from 'prop-types';
import cn from "../../../../utils/cn";
import Icon from "../../../Display/Icon/Icon";
import Expandable from "../../../Display/Expandable/Expandable";
import InputField from "../../../Form/InputField/InputField";
import CheckBoxField from "../../../Form/CheckBoxField/CheckBoxField";
import filterServiceTypeOptions from "../utils/filterServiceTypeOptions";
import { filterOptionsPropType } from "../utils/propTypes";
import SupersetAddProgramButton from "./SupersetAddResourceButton";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DISPLAY_NAME = 'search-program-card';
function SupersetAddResource(_ref) {
  var _services$0$children$, _services$0$children;
  let {
    services,
    programId,
    isSelected,
    onSelectProgram,
    selectedServicesIds
  } = _ref;
  const [searchText, setSearchText] = useState('');
  const [filteredServices, setFilteredServices] = useState(services);
  const debouncedSearch = debounce(s => {
    const results = filterServiceTypeOptions(services, s);
    setFilteredServices(results);
  }, 300);
  useEffect(() => {
    if (searchText) {
      debouncedSearch(searchText);
    }
  }, [searchText, debouncedSearch]);
  if (services.length === 1 && ((_services$0$children$ = (_services$0$children = services[0].children) === null || _services$0$children === void 0 ? void 0 : _services$0$children.length) !== null && _services$0$children$ !== void 0 ? _services$0$children$ : 0) <= 1) {
    return /*#__PURE__*/_jsx(SupersetAddProgramButton, {
      disabled: !services.length,
      isSelected: isSelected,
      onSelectProgram: onSelectProgram,
      onClick: () => {
        // if this is clickable, it's got services
        const serviceId = services[0].children.length ? services[0].children[0].value : services[0].value;
        onSelectProgram(serviceId);
      }
    });
  }
  return /*#__PURE__*/_jsx(Expandable, {
    className: cn("".concat(DISPLAY_NAME, "__add-program-element ").concat(DISPLAY_NAME, "__add-program-expandable"), 'w-full flex items-center justify-center p-3 rounded', 'text-white p-0', isSelected ? 'resource-selected' : 'resource-not-selected'),
    initiallyCollapsed: true,
    header: selectedServicesIds.length > 0 ? "".concat(selectedServicesIds.length, " ").concat(pluralize(selectedServicesIds.length, 'Resource'), " Added") : 'Add Resource',
    id: "add-program-expandable-".concat(programId),
    children: /*#__PURE__*/_jsxs("div", {
      className: "service-selection-area mt-2",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "relative",
        children: [/*#__PURE__*/_jsx(Icon, {
          icon: "Search",
          className: "absolute left-0 top-0 pl-2 h-full"
        }), /*#__PURE__*/_jsx(InputField, {
          id: "service-search-input-".concat(programId),
          className: "m-0",
          placeholder: "Select service from below or search available service types",
          hideHint: true,
          hideError: true,
          hideLabel: true,
          label: "service-search-input-".concat(programId),
          onChange: e => setSearchText(e.target.value)
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "service-selection-drawer mt-3 overflow-y-auto cursor-auto",
        children: filteredServices.map(serviceParent => /*#__PURE__*/_jsxs("fieldset", {
          className: "service-select-section flex my-2 border-dark-pale-blue",
          children: [/*#__PURE__*/_jsx("div", {
            className: "w-1/3",
            children: /*#__PURE__*/_jsx("legend", {
              className: "ml-2",
              children: serviceParent.label
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "w-2/3",
            children: serviceParent.children.map(serviceChild => /*#__PURE__*/_jsx(CheckBoxField, {
              id: programId + serviceChild.value,
              label: serviceChild.label,
              onChange: () => onSelectProgram(serviceChild.value),
              checked: selectedServicesIds.some(id => id === serviceChild.value),
              showError: false,
              showHint: false
            }, programId + serviceChild.value))
          })]
        }, serviceParent.value))
      })]
    })
  });
}
SupersetAddResource.propTypes = {
  selectedServicesIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  services: filterOptionsPropType.isRequired,
  programId: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelectProgram: PropTypes.func.isRequired
};
export default /*#__PURE__*/React.memo(SupersetAddResource, (prevProps, nextProps) => {
  let areServicesEqual = true;
  for (let i = 0; i < prevProps.services.length; i += 1) {
    if (prevProps.selectedServicesIds[i] !== nextProps.selectedServicesIds[i]) {
      areServicesEqual = false;
      break;
    }
  }
  return areServicesEqual && prevProps.isSelected === nextProps.isSelected && prevProps.selectedServicesIds.length === nextProps.selectedServicesIds.length;
});
//# sourceMappingURL=SupersetAddResource.js.map